package org.vreo.devicehub.features.liveAccess.domain

/**
 * WebRTC connection mode between client and target device
 */
enum class WebRtcConnectMode {
    NORMAL,                     // Standard peer-to-peer
    PRIVATE_TURN_SERVER,        // Routed via proprietary delf-hosted TURN server
}
